<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' @child-event='getTextVal' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item' :template-data='templateData'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>
		<List v-show='isUpdata' :data-val="valData" @child-event='getListVal'></List>
		<a href="/static/export1.xlsx" download="export" style="color: #FF0000; text-decoration: underline">下载导入模板</a>
		<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" size="large" type="primary">采购验收确认</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import List from '../components/List.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		sendMessage,
		getFlowTemplate,
		getMediaId,
		GetPendingProcessById,
		getLastFlowTemplate
	} from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose,
			List
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				formLoading: false,
				listLoading: false,
				applyTemplateData: null,
				isUpdata:false,
				valData: {
					TotalCount: 0,
					listTitle: [{
							type: 'selection',
							width: 45,
							align: 'center',
							fixed: 'left'
						},
						{
							title: '物品名称',
							key: 'AssetsCode',
							width: 120,
							disabled: true
						},
						{
							title: '品牌规格',
							key: 'SupplierName',
							width: 220,
							disabled: true
						},
						{
							title: '单位',
							key: 'AssetsSpecMode',
							width: 120,
							disabled: true
						},
						{
							title: '验收数量',
							key: 'AssetsName',
							width: 180,
							disabled: true
						},
						{
							title: '验收单价',
							key: 'UnitName',
							width: 180,
							disabled: true
						},
						{
							title: '验收小计',
							key: 'AssetsTypeName',
							width: 120,
							disabled: true
						},
						{
							title: '是否借款',
							key: 'DepartPositionName',
							width: 120,
							disabled: true
						},
						{
							title: '借款金额',
							key: 'UseDepartName',
							width: 120,
							disabled: true
						},
						{
							title: '备注',
							key: 'AssetsPrice',
							width: 70,
							disabled: true
						}
					],
					listData: [],
					isCheck:false,
					flowId:null
				}
			}
		},
		created() {
			stringUtils.setAddIsShow(false);
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.flowId = this.$route.query.flowId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
		},
		methods: { //方法
			
			clickChoose(dataVal, name) {
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var depart = res.result.departmentList[0]; // 已选的部门列表
						dataVal.Values.push([depart.id, depart.name]);
						dataVal.Value = depart.name;
					}
				})
			},

			getTemplate: async function() {
				await GetPendingProcessById(this.flowId).then(response =>{
					if(response.Body==null){
						this.Message({
							message: '该流程已经处理完成',
							type: 'success',
							duration: 3 * 1000
						});
						setTimeout(() => {
							this.$router.push("/Pricing");
						}, 1000)
						return;
					}
				})
				await this.getFlowTemplateInfo();
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var jobLevel = this.logInfo.JobLevel;
				var sumPrice = 0.00;
				var hrat = this;
				await getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					controls.TemplateContent.Controls.forEach(async (item, index) => {
						var departs = this.logInfo.fullName.split("/");
						if (item.Property.Title[0].Text == "维修信息") {
							item.IsShow = false;
						}

						if (item.Property.Title[0].Text == "行政主任") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "行政经理") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "小战区区董") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "大战区区董") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "经理/总监") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "总经理") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "申请人员") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "验收人员") {
							item.Disable = true;
							item.Value = this.logInfo.EmpName;
							item.Values = [[this.logInfo.EmpNo,this.logInfo.EmpName]];
						}
						// if (item.Property.Title[0].Text == "申请人员部门") {
						// 	item.Disable = true;
						// 	item.IsShow = false;
						// }
						if (item.Property.Title[0].Text == "核价人员") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "维修") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "申请原因") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "申请类别1") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "申请类别2") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "配送地点") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "收货人联系方式") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "配送到位时间") {
							item.Disable = true;
							if (hrat.applyTemplateData != null) {
								item.Value = hrat.applyTemplateData.TemplateContent.Controls.filter(t => {
									return t.Property.Title[0].Text == "配送到位时间"
								})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "备注") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "备注") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "申请人员") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "申请人员工号") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "核价人员") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "申请表别称") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "供应商名称") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "供应商联系方式") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "监控单价") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "确认供应商") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "确认价格") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "是否录入资产") {
							item.Disable = true;
						}
						// if (item.Property.Title[0].Text == "是否为需回收物资") {
						// 	item.Disable = true;
						// }
						if (item.Property.Title[0].Text == "核价确认") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "内容信息") {
							item.IsShow = false;
							this.$set(item, 'addIsShow', true);
						}
						if (item.Property.Title[0].Text == "合计") {
							item.Disable = true;
							item.Value = 0.00;
						}
						if (item.Property.Title[0].Text == "申请金额") {
							item.Disable = true;
							if (hrat.applyTemplateData != null) {
								item.Value = hrat.applyTemplateData.TemplateContent.Controls.filter(t => {
									return t.Property.Title[0].Text == "合计"
								})[0].Value;
							}
							
						}
						if (item.Property.Title[0].Text == "核价说明") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "申请人职位") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "申请人部门") {
							item.Disable = true;
						}
						
						if (item.Property.Title[0].Text == "核价人员工号") {
							item.Disable = true;
							if (hrat.applyTemplateData != null) {
								item.Value = hrat.applyTemplateData.TemplateContent.Controls.filter(t => {
									return t.Property.Title[0].Text == "核价人工号"
								})[0].Value;
							}
						}
						if (item.Property.Title[0].Text == "申请部门") {
							item.Disable=true;
						}
						if (item.Property.Title[0].Text == "核价人部门") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "核价人职位") {
							item.Disable = true;
						}
						if (item.Property.Title[0].Text == "申请项目内容") {
							item.Config.Table.Children.forEach(e =>{
								e.Disable = true;
							})
						}
						if (item.Property.Title[0].Text == "验收人员工号") {
							item.Disable = true;
							item.Value = this.logInfo.EmpNo;
						}
						if (item.Property.Title[0].Text == "验收人员部门") {
							item.Disable = true;
							item.Value = this.logInfo.DeptName;
						}
						if (item.Property.Title[0].Text == "验收人员职位") {
							item.Disable = true;
							item.Value = this.logInfo.PositionName;
						}
						if(item.Property.Title[0].Text=="超出申请金额"){
							item.IsShow = false;
							item.Value = 0;
						}
						if(item.Property.Title[0].Text=="合计"){
							item.IsShow = false;
						}
						if(item.Property.Title[0].Text=="实付金额"){
							item.IsShow = false;
							item.Disable = true;
						}
						if(item.Property.Title[0].Text=="请选择审批流程"){
							item.IsShow = false;
						}
						if(item.Property.Title[0].Text=="应退补款"){
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "关联核价单") {
							item.Value = hrat.spNo;
							item.IsShow = true;
						}
					});
					hrat.templateData = hrat.assignControl(controls, hrat.logInfo);
					hrat.templateData = await hrat.assignControlBySpNo(controls, hrat.spNo, hrat.flowId);
          console.log(hrat.templateData)
          if (hrat.spNo === "202212140021" && hrat.flowId === "202212142BR"){
            hrat.templateData.TemplateContent.Controls.forEach(item => {
              if (item.Property.Title[0].Text == "申请人职位") {
                item.Value = "行政主管";
              }
              if (item.Property.Title[0].Text == "申请人员") {
                item.Values = [["SC18008706","雷艳"]];
                item.Value = "雷艳"
              }
              if (item.Property.Title[0].Text == "申请人员工号") {
                item.Value = "SC18008706"
              }
            })
          }
					hrat.listLoading = false;
				});
			},
			getEmployeeRelation: async function() {
				await getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getFlowTemplateInfo: async function() {
				await getLastFlowTemplate(this.flowId).then(response => {
					this.applyTemplateData = response.Body;
				});
			},
			getTextVal(val, name) {
				if (name == "实付金额") {
					var controls = this.templateData.TemplateContent.Controls;
					var applyMoney = parseFloat(controls.filter(item => item.Property.Title[0].Text == "申请金额")[0].Value).toFixed(2);
					var sureMoney = parseFloat(val).toFixed(2);
					var money = sureMoney - applyMoney;
					if (money <= 0) {
						money = 0.00;
					}
					controls.filter(item => item.Property.Title[0].Text == "超出申请金额")[0].Value = money;
				}
			},
			getSelectorVal(val, name) {
				if (name == "实际采购内容是否与申请内容一致") {
					var controls = this.templateData.TemplateContent.Controls;
					var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Value[0].Text == "不一致" && val.indexOf(item.Key) > -1;
						})[0];

					var control = controls.filter(item => item.Property.Title[0].Text == "内容信息")[0];
					this.$set(control, 'addIsShow', true);
					if (option != null) {
						control.IsShow = true;
					} else {
						control.IsShow = false;
					}
					control.Config.Table.Children.forEach(item => {
					  // if (item.Property.Title[0].Text === "是否借款"){
            //   item.Value = "option-1601344706794" // 否
            // }
            // if (item.Property.Title[0].Text === "借款金额"){
            //   item.Value = "0"
            // }
            // if (item.Property.Title[0].Text === "备注"){
            //   item.Value = "无"
            // }
						item.Property.Require = control.IsShow ? 1 : 0;
					});
					controls.forEach(item => {
						if(item.Property.Title[0].Text == "实付金额"){
							item.IsShow = control.IsShow;
							item.Value = control.IsShow?'':'0';
						}
						if(item.Property.Title[0].Text == "应退补款"){
							item.IsShow = control.IsShow;
							item.Value = control.IsShow?'':'0';
						}
					})
          let applyContent = this.templateData.TemplateContent.Controls.filter(e => e.Property.Title[0].Text.indexOf("申请项目内容") !== -1);
					let size = applyContent.length - 1
          const title = "内容信息"
          const type = "add"
          // const table = controls
          for (let i = 0; i < size; i++) {
            this.tableoperation(title, type, control, this);
          }
          let tControls = this.templateData.TemplateContent.Controls
          for (let applyContentElement of applyContent) {
            // console.log(applyContentElement)
            const endFix = applyContentElement.Property.Title[0].Text.replace("申请项目内容","");
            let key = "内容信息" + endFix
            for (let i = 0; i < tControls.length; i++) {
              if (tControls[i].Property.Title[0].Text === key) {
                let tempMap = new Map()
                for (let child of applyContentElement.Config.Table.Children) {
                  tempMap.set(child.Property.Title[0].Text,child.Value)
                }
                for (let j = 0; j < tControls[i].Config.Table.Children.length; j++) {
                  let tempkey = tControls[i].Config.Table.Children[j].Property.Title[0].Text
                  if (tempkey === "借款金额") {
                    tControls[i].Config.Table.Children[j].Value = "0"
                    continue
                  }
                  if (tempkey === "是否借款") {
                    tControls[i].Config.Table.Children[j].Value = "option-1601344706794"
                    continue
                  }
                  if (tempkey === "品牌规格"){
                    tempkey = "规格型号"
                  }
                  if (tempkey === "验收数量"){
                    tempkey = "数量"
                  }
                  if (tempkey === "验收单价"){
                    tempkey = "单价"
                  }
                  if (tempkey === "验收小计"){
                    tempkey = "小计"
                  }
                  let tempHas = tempMap.has(tempkey)
                  if (!tempHas){
                    continue
                  }
                  let tempValue = tempMap.get(tempkey);
                  tControls[i].Config.Table.Children[j].Value = tempValue
                }
              }
            }
          }
					this.isUpdata = control.IsShow;
				}
				if (name == "结算金额") {
					var controls = this.templateData.TemplateContent.Controls;
					var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Value[0].Text == "大于申请金额" && val.indexOf(item.Key) > -1;
						})[0];
					var control = controls.filter(item => item.Property.Title[0].Text == "维修信息")[0];
					if (option != null) {
						control.IsShow = true;
					} else {
						control.IsShow = false;
					}
				}
			},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
        console.log(val)
        console.log(type)
        console.log(datas)
				this.tableoperation(val, type, datas, this);
			},
			getListVal: async function(data, type) {
				var that = this;
				var indexs = 0;
				var controls = that.templateData.TemplateContent.Controls.filter((e,index) => { if(e.Property.Title[0].Text == "内容信息"){indexs = index; return e}})[0];
				let controlsString = JSON.stringify(controls);
				for(var j = that.templateData.TemplateContent.Controls.length-1;j>=0;j--){
					if(that.templateData.TemplateContent.Controls[j].Property.Title[0].Text.indexOf("内容信息")>-1){
						that.templateData.TemplateContent.Controls.splice(j,1);
					}
				}
				for(var i = 0;i<data.length;i++){
					let control = JSON.parse(controlsString);
					control.IsShow = true;
					control.Config.Table.Children.forEach( e => {
						if(e.Property.Title[0].Text == '备注'){
							e.Disable = true;
							e.Value = '空';
						}
						 let children = data[i].filter(item => {
							if(item.text == e.Property.Title[0].Text){
								if(item.text == "是否借款"){
									let options = e.Config.Selector.Options.filter(y => {
										if(item.val == y.Value[0].Text){
											return y
										}
									})[0]
									if(options!=null){
										e.Value = options.Key;
										e.Disable = true;
									}
								}
								return item.val
							}
							
						})[0];
						if(children != null){
							if(e.Property.Title[0].Text != "是否借款"){
								e.Value = children.val;
								e.Disable = true;
							}
						}
					})
					that.templateData.TemplateContent.Controls.splice(indexs+1,0,control);
				}
				
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				isSubmit = true;
				this.listLoading = true;
				var empNo = '';
				this.templateData.TemplateContent.Controls.forEach(e=>{
					if(e.Property.Title[0].Text == "申请人员工号"){
						empNo = e.Value;
					}
				})
				var isDelete = false;
				this.templateData.TemplateContent.Controls.forEach(e=>{
					if(e.Property.Title[0].Text == "实际采购内容是否与申请内容一致"){
						e.Config.Selector.Options.forEach(option =>{
							if(option.Key == e.Value && option.Value[0].Text == '一致'){
								isDelete = true;
							}
						} )
					}
				})
				if(isDelete){
					for(var i = this.templateData.TemplateContent.Controls.length-1;i>-1;i--){
						var control = this.templateData.TemplateContent.Controls[i];
						if(control.Property.Title[0].Text.indexOf("内容信息")>-1){
							this.templateData.TemplateContent.Controls.splice(i,1);
						}
						if(control.Property.Title[0].Text.indexOf("实付金额")>-1){
							this.templateData.TemplateContent.Controls.splice(i,1);
						}
					}
				}
				
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var control=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请人员"})[0]
				var control4=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请人员工号"})[0]
				
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请人信息："+control.Value+" "+control4.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				
				var control2=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "申请部门"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				var NameOfData = "";
				info.SummaryInfo.push({"Text":"申请表别称："+control2.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var control3=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "确认价格"})[0]
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"确认价格："+control3.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				this.templateData.SummaryList=SummaryList;

				//提交
				submitProcess(this.templateId, empNo, this.spNo, this.templateData, this.flowId).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/Pricing");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
				});
			}
		}

	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
